import { RepresentativeOfListViewDTO } from './representative-list-view-dto';
import { FormEditStyle } from '../../enums/configuration/form-edit-style';

export class RepresentativeListWidgetDataModel {
    public FormEditStyle: FormEditStyle;
    public representatives: RepresentativeOfListViewDTO[];
    public totalRecords: number;    
}